var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoupe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7988 11.9763C9.66509 12.8586 8.23995 13.3841 6.69208 13.3841C2.99615 13.3841 0 10.388 0 6.69206C0 2.99614 2.99615 0 6.69208 0C10.388 0 13.3842 2.99614 13.3842 6.69206C13.3842 8.23995 12.8586 9.6651 11.9763 10.7988L15.7561 14.5787C16.0813 14.9038 16.0813 15.431 15.7561 15.7561C15.431 16.0813 14.9038 16.0813 14.5787 15.7561L10.7988 11.9763ZM11.8095 6.69206C11.8095 9.51836 9.51838 11.8095 6.69208 11.8095C3.86578 11.8095 1.57461 9.51836 1.57461 6.69206C1.57461 3.86577 3.86578 1.5746 6.69208 1.5746C9.51838 1.5746 11.8095 3.86577 11.8095 6.69206Z",
    fill: "#1D1D1B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoupe);
export default __webpack_public_path__ + "static/media/loupe.926b092df530a149b383764fbe626288.svg";
export { ForwardRef as ReactComponent };